import { makeIconDef } from "./makeIconDef";
import React from "react";
export var StopIconDef = {
    stop: makeIconDef('stop', {
        regular: function () { return React.createElement("rect", { x: "4.5", y: "4.5", width: "15", height: "15", rx: "1.5", stroke: "currentColor" }); },
        filled: function () { return React.createElement("rect", { x: "4", y: "4", width: "16", height: "16", rx: "2", fill: "currentColor" }); }
    })
};
